// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3UfPZ","head":"Table_head__1NdMl","col":"Table_col__Wl7Wt"};